import { render, staticRenderFns } from "./car-buy.vue?vue&type=template&id=3e8880aa"
import script from "./car-buy.vue?vue&type=script&lang=js"
export * from "./car-buy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TippyQuestion: require('/var/www/components/tippy/tippy-question.vue').default,ButtonCallFull: require('/var/www/components/button/button-call-full.vue').default,ButtonAutoteka: require('/var/www/components/button/button-autoteka.vue').default})
